import { EmpresaFilePayload } from "./create-empresa-file.interfaces";
import { InaseSvg } from "./inase-svg";

export const createEmpresaFile = (data: EmpresaFilePayload): string => {
  return `
  <!DOCTYPE html>
  <html lang="es">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Registro General de Semilleristas</title>
  <style>
    @page {
      size: A4;
      margin: 10mm;
    }

    * {
      box-sizing: border-box;
    }

    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      background-color: #ffffff;
      width: 210mm;
      min-height: 297mm;
      font-size: 12px;
      line-height: 1.4;
    }

    .container {
      width: 100%;
      margin: 0 auto;
      padding: 5mm;
      box-sizing: border-box;
    }

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    h1, h2 {
      text-align: center;
      color: #004a8f;
      margin: 5px 0;
    }

    h1 {
      font-size: 16px;
      font-weight: bold;
    }

    h2 {
      font-size: 12px;
      font-weight: normal;
    }

    .section-title {
      font-size: 12px;
      font-weight: bold;
      color: #013366;
      margin: 15px 0 10px 0;
      padding-bottom: 5px;
      text-align: center;
      border-bottom: 1px solid #ccc;
    }

    .key {
      color: #013366;
      font-weight: bold;
    }

    .data {
      font-size: 10px;
      margin-bottom: 8px;
      line-height: 1.3;
      word-wrap: break-word;
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      margin: 10px 0;
      font-family: Arial, sans-serif;
      table-layout: fixed;
    }

    .table th, .table td {
      border: 1px solid #000;
      padding: 4px 6px;
      font-size: 9px;
      text-align: left;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .table th {
      font-weight: bold;
      background-color: #f5f5f5;
    }

    .table td {
      max-width: 0;
    }

    section {
      margin-bottom: 15px;
      page-break-inside: avoid;
    }

    .item-block {
      margin-bottom: 10px;
      padding: 5px 0;
    }

    .svg-container {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
    }

    footer {
      font-size: 9px;
      text-align: center;
      margin-top: 20px;
      border-top: 1px solid #000;
      padding-top: 5px;
    }

    .footer-content {
      color: #003366;
    }

    @media print {
      body {
        width: 210mm;
        height: 297mm;
      }

      .container {
        max-width: none;
        width: 100%;
        padding: 5mm;
      }
    }
  </style>
</head>

<body>
  <div class="container">
    <div class="title">
      <div class="svg-container">${InaseSvg()}</div>
      <div>
        <h1>REGISTRO GENERAL DE SEMILLERISTAS</h1>
        <h2 style="color: #003366;">${new Date().toLocaleDateString('es-ES')}</h2>
      </div>
      <div class="svg-container"></div>
    </div>

    <!-- Sección Empresa -->
    <section>
      <div class="section-title">EMPRESA</div>
      <p class="data"><span class="key">Denominación social:</span> ${data.empresa.denominacionSocial || 'N/A'}</p>
      <p class="data"><span class="key">Nombre de la empresa:</span> ${data.empresa.nombreFantasia || 'N/A'}</p>
      <p class="data"><span class="key">RUT:</span> ${data.empresa.rut || 'N/A'}</p>
      <p class="data"><span class="key">BPS:</span> ${data.empresa.bps || 'N/A'}</p>
      <p class="data"><span class="key">Estado:</span> ${data.empresa.estado || 'N/A'}</p>
      <p class="data"><span class="key">Fecha de estado:</span> ${data.empresa.fechaDeEstado || 'N/A'}</p>
      <p class="data"><span class="key">RGS:</span> ${data.empresa.rgs || 'N/A'}</p>
      <p class="data"><span class="key">Teléfonos:</span> ${data.empresa.telefono || 'N/A'}</p>

      <div class="section-title">Correos electrónicos</div>
      <p class="data"><span class="key">Contacto técnico:</span> ${data.empresa.correosElectronicos?.contactoTecnico || 'N/A'}</p>
      <p class="data"><span class="key">Contacto administrativo:</span> ${data.empresa.correosElectronicos?.contactoAdministrativo || 'N/A'}</p>
      <p class="data"><span class="key">Contacto finanzas:</span> ${data.empresa.correosElectronicos?.contactoFinanzas || 'N/A'}</p>

      <div class="section-title">Domicilios</div>
      <p class="data"><span class="key">Domicilio fiscal:</span> ${formatDomicilio(data.empresa.domicilioFiscal)}</p>
      <p class="data"><span class="key">Domicilio constituido:</span> ${formatDomicilio(data.empresa.domicilioConstituido)}</p>
      <p class="data"><span class="key">Domicilio correspondiente:</span> ${formatDomicilio(data.empresa.domicilioCorrespondiente)}</p>
    </section>

    <!-- Sección Integrantes -->
    ${data.integrantes?.length ? `
    <section>
      <div class="section-title">INTEGRANTES</div>
      <table class="table">
        <thead>
          <tr>
            <th style="width: 35%;">Nombre</th>
            <th style="width: 25%;">Rol</th>
            <th style="width: 20%;">Documento</th>
            <th style="width: 20%;">Estado</th>
          </tr>
        </thead>
        <tbody>
          ${data.integrantes.map(integrante => `
            <tr>
              <td>${integrante.nombre || 'N/A'}</td>
              <td>${integrante.rol || 'N/A'}</td>
              <td>${integrante.documento || 'N/A'}</td>
              <td>${integrante.estado || 'N/A'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </section>
    ` : ''}

    <!-- Sección Depósitos -->
    ${data.depositosYDependendencias.depositos?.length ? `
    <section>
      <div class="section-title">DEPÓSITOS</div>
      ${data.depositosYDependendencias.depositos.map(deposito => `
        <div class="item-block">
          <p class="data"><span class="key">Nombre:</span> ${deposito.nombre || 'N/A'}</p>
          <p class="data"><span class="key">Dirección:</span> ${deposito.direccion || 'N/A'}</p>
          <p class="data"><span class="key">País:</span> ${deposito.pais || 'N/A'}</p>
          <p class="data"><span class="key">Departamento:</span> ${deposito.departamento || 'N/A'}</p>
          <p class="data"><span class="key">Localidad:</span> ${deposito.localidad || 'N/A'}</p>
          <p class="data"><span class="key">Teléfonos:</span> ${deposito.telefonos || 'N/A'}</p>
          <p class="data"><span class="key">Correos Electrónicos:</span> ${deposito.correosElectronicos || 'N/A'}</p>
        </div>
      `).join('')}
    </section>
    ` : ''}

    <!-- Sección Viveros -->
    ${data.depositosYDependendencias.viveros?.length ? `
    <section>
      <div class="section-title">VIVEROS</div>
      ${data.depositosYDependendencias.viveros.map(vivero => `
        <div class="item-block">
          <p class="data"><span class="key">Nombre:</span> ${vivero.nombre || 'N/A'}</p>
          <p class="data"><span class="key">Especies:</span> ${vivero.especies || 'N/A'}</p>
          <p class="data"><span class="key">Estado:</span> ${vivero.estado || 'N/A'}</p>
        </div>
      `).join('')}
    </section>
    ` : ''}

    <!-- Sección Laboratorios -->
    ${data.depositosYDependendencias.laboratorios?.length ? `
    <section>
      <div class="section-title">LABORATORIOS</div>
      ${data.depositosYDependendencias.laboratorios.map(laboratorio => `
        <div class="item-block">
          <p class="data"><span class="key">Nombre:</span> ${laboratorio.nombre || 'N/A'}</p>
          <p class="data"><span class="key">Dirección:</span> ${laboratorio.direccion || 'N/A'}</p>
          <p class="data"><span class="key">País:</span> ${laboratorio.pais || 'N/A'}</p>
          <p class="data"><span class="key">Departamento:</span> ${laboratorio.departamento || 'N/A'}</p>
          <p class="data"><span class="key">Localidad:</span> ${laboratorio.localidad || 'N/A'}</p>
          <p class="data"><span class="key">Teléfonos:</span> ${laboratorio.telefonos || 'N/A'}</p>
          <p class="data"><span class="key">Correos Electrónicos:</span> ${laboratorio.correosElectronicos || 'N/A'}</p>
          <p class="data"><span class="key">Equipamientos:</span> ${laboratorio.equipamientos || 'N/A'}</p>
        </div>
      `).join('')}
    </section>
    ` : ''}

    <!-- Sección Sitios de Procesamiento -->
    ${data.depositosYDependendencias.sitiosProcesamiento?.length ? `
    <section>
      <div class="section-title">SITIOS DE PROCESAMIENTO</div>
      ${data.depositosYDependendencias.sitiosProcesamiento.map(sitio => `
        <div class="item-block">
          <p class="data"><span class="key">Dirección:</span> ${sitio.direccion || 'N/A'}</p>
          <p class="data"><span class="key">País:</span> ${sitio.pais || 'N/A'}</p>
          <p class="data"><span class="key">Departamento:</span> ${sitio.departamento || 'N/A'}</p>
          <p class="data"><span class="key">Localidad:</span> ${sitio.localidad || 'N/A'}</p>
          <p class="data"><span class="key">Teléfonos:</span> ${sitio.telefonos || 'N/A'}</p>
          <p class="data"><span class="key">Correos Electrónicos:</span> ${sitio.correosElectronicos || 'N/A'}</p>
          <p class="data"><span class="key">Brinda Servicios:</span> ${sitio.brindaServicios || 'N/A'}</p>
          <p class="data"><span class="key">Equipamientos:</span> ${sitio.equipamientos || 'N/A'}</p>
        </div>
      `).join('')}
    </section>
    ` : ''}

    <!-- Sección Máquina Móvil -->
    ${data.depositosYDependendencias.maquinaMovil?.length ? `
    <section>
      <div class="section-title">MÁQUINA MÓVIL</div>
      ${data.depositosYDependendencias.maquinaMovil.map(maquina => `
        <div class="item-block">
          <p class="data"><span class="key">Número:</span> ${maquina.numero || 'N/A'}</p>
          <p class="data"><span class="key">Teléfonos:</span> ${maquina.telefonos || 'N/A'}</p>
          <p class="data"><span class="key">Correos Electrónicos:</span> ${maquina.correosElectronicos || 'N/A'}</p>
          <p class="data"><span class="key">Brinda Servicios:</span> ${maquina.brindaServicios || 'N/A'}</p>
          <p class="data"><span class="key">Equipamientos:</span> ${maquina.equipamientos || 'N/A'}</p>
        </div>
      `).join('')}
    </section>
    ` : ''}

    <!-- Sección Movimiento de Trámite -->
    ${data.movimientoTramite?.length ? `
    <section>
      <div class="section-title">HISTÓRICO DE MOVIMIENTOS</div>
      <table class="table">
        <thead>
          <tr>
            <th style="width: 25%;">Fecha de Completado</th>
            <th style="width: 50%;">Observación</th>
            <th style="width: 25%;">Estado</th>
          </tr>
        </thead>
        <tbody>
          ${data.movimientoTramite.map((movimiento: any) => `
            <tr>
              <td>${movimiento.fecha_completado || 'N/A'}</td>
              <td>${movimiento.observacion || 'No tiene'}</td>
              <td>${movimiento.estado || 'N/A'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </section>
    ` : ''}

  </div>
</body>
</html>
`;
}

// Función auxiliar para formatear domicilios
function formatDomicilio(domicilio: any): string {
  if (!domicilio) return 'N/A';

  const parts = [
    domicilio.direccion,
    domicilio.localidad,
    domicilio.departamento,
    domicilio.pais
  ].filter(part => part && part.trim() !== '');

  return parts.length > 0 ? parts.join(', ') : 'N/A';
}



